import React from "react";
import { ReferenceInput, SelectInput } from "react-admin";
import SubmitFilters from "../components/filters/SubmitFilters";
import SearchInput from "../components/inputs/SearchInput";

const Filters = (props) => {
	return (
		<SubmitFilters {...props}>
			<SearchInput source="q" alwaysOn fullWidth />
			<ReferenceInput
				source="contest_id"
				fullWidth
				reference="contests"
				resettable
			>
				<SelectInput optionText="title" />
			</ReferenceInput>
		</SubmitFilters>
	);
};
export default Filters;
